import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "bmt_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}

export const adminLogin = (username, password) =>
  api.post("/auth/login", { username, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const listResults = () => api.get("/admin/results").then((r) => r.data);
export const createResult = (payload) =>
  api.post("/results", payload).then((r) => r.data);
export const updateResult = (id, payload) =>
  api.put(`/results/${id}`, payload).then((r) => r.data);
export const deleteResult = (id) =>
  api.delete(`/results/${id}`).then((r) => r.data);

export default api;
